'use strict';

var EFC = window.EFC = (window.EFC || {});
EFC.DescExpander = (function($) {
  var $mobileExpandedElements;
  var $expanderButtons;
  
  function init() {
    $expanderButtons = $('.descExpander__button');
    $expanderButtons.on('click', toggleExpansion);

    $mobileExpandedElements = $expanderButtons.filter(function() { return !!$(this).closest('.descExpander--expandedOnMobile').length; }); 
    
    window.addEventListener('resize', showDefaultExpansions);
    showDefaultExpansions();
    setDescribedByAttrs();
  }
  
  function toggleExpansion() {
    var $button = $(this);
    
    var isExpanding = ($button.attr('aria-expanded') == 'false');
    var $expander = $button.closest('.descExpander');
    var $content = $expander.find('.descExpander__content');
    var content = $content[0];
    
    if (isExpanding) {
      // This also forces reflow
      content.style.maxHeight = null;
      content.style.display = 'block';

      // 40: vertical padding
      content.renderedHeight = (content.offsetHeight + 80 + 40) + 'px'; 
      content.style.maxHeight = 0;
      
      window.requestAnimationFrame(function(x) {
        content.style.maxHeight = content.renderedHeight;
      });
      
      $expander.addClass('descExpander--expanded');
    }
    else {
      $expander.removeClass('descExpander--expanded');

      window.requestAnimationFrame(function() { content.style.maxHeight = 0; });
      window.setTimeout(function() { content.style.display = "none" }, 400);
    }
    
    $button.attr('aria-expanded', (isExpanding) ? 'true' : 'false');
  }
  
  function setDescribedByAttrs() {
    $expanderButtons.closest('.descExpander__parent').each(function() {
      var descId = $(this).find('.descExpander__content').attr('id');
      this.setAttribute('aria-describedby', descId);
    });
  }
  
  function showDefaultExpansions() {
    var $content = $('.descExpander__content');
    $content.each(function() { this.style.maxHeight = null; });
    
    if (!$mobileExpandedElements.length) { return; }

    const width  = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const isMobileView = (width < EFC.breakpoints.laptop);
    const mobileViewChanged = (document.efc_wasMobileView !== isMobileView);
    document.efc_wasMobileView = isMobileView;
    
    // Switching from Mobile to Desktop behaviour
    $('.descExpander__button').each(function() {
      var $button = $(this);
      var content = $button.closest('.descExpander').find('.descExpander__content')[0];
      
      if (!mobileViewChanged) {
        return;
      }
      
      // Switching from desktop view to mobile
      if (isMobileView) {
        $button[0].style.display = 'none';
        content.style.maxHeight = null;
        content.style.display = "block";
      }
      else {
        $button[0].style.display = "block";
        content.style.maxHeight = null;
        content.style.display = null;
      }
    });

    
  }
  
  $(init);
})(jQuery);